window.SubscriptionAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = publicConfiguration.SubscriptionServerBaseURL;
    _protected.setApiUrl(url);

    self.getJobsAlertsSubscription = function (token) {
        var deferred = $q.defer();

        var params = { 'token': token };

        _protected.request("jobs/alerts/subscriptions", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.sendPreferences = function (brandId, email) {
        var deferred = $q.defer();

        var params = {
            base_brand_id: brandId,
            email: email
        };

        _protected.request("jobs/alerts/subscriptions/preferences/send", "POST", params)
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    //check if email subscribed
    self.checkEmailSubscribed = function (brandId, email) {
        var deferred = $q.defer();

        var payload = {
            brand_id: brandId,
            email: email
        };

        _protected.request('jobs/alerts/subscriptions/status', 'GET', payload)
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.submitJobAlertSubscription = function (payload) {
        var deferred = $q.defer();

        _protected.request("jobs/alerts/subscriptions", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.updateJobAlertSubscription = function (subId, token, payload) {
        var deferred = $q.defer();

        _protected.request("jobs/alerts/subscriptions/" + subId + "?token=" + encodeURIComponent(token), "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.removeSubscription = function (subId, token, payload) {
        var deferred = $q.defer();

        _protected.request("jobs/alerts/subscriptions/" + subId + "?token=" + encodeURIComponent(token), "DELETE")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.sendUpdateJobAlertPrefrencesEmail = function (payload) {
        var deferred = $q.defer();

        var params = payload;

        _protected.request("jobs/alerts/subscriptions/preferences/send", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.verifySubscription = function (token) {
        var deferred = $q.defer();

        var params = {};

        _protected.request("jobs/alerts/subscriptions/verify?token=" + encodeURIComponent(token), "POST", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.unsubscribeFromJobAlertSubscription = function (subscriptionId, token) {
        var deferred = $q.defer();

        _protected.request("jobs/alerts/subscriptions/" + subscriptionId + "?token=" + encodeURIComponent(token), "DELETE")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandSubscriptionsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + "/settings", 'GET')
            .then(function (result) {
                if (result.data && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };
});
